import { ResourceConfig } from '../types/resource'
import { RouteConfig } from '../types/route'

/**
 * 过滤出用于解析菜单的路由配置
 */
const filterMenuConfigs = (routes: RouteConfig[]): RouteConfig[] => {
  const menuConfigs: RouteConfig[] = []

  for (const route of routes) {
    const children = route.children
      ? filterMenuConfigs(route.children)
      : undefined
    // 没有标题的排除掉
    if (!route.title) {
      if (children?.length) {
        menuConfigs.push(...children)
      }
    } else {
      menuConfigs.push({
        ...route,
        children: children?.length ? children : undefined
      })
    }
  }

  return menuConfigs
}

/**
 * 在子菜单列表中查找默认路由
 *
 * @param routes 路由配置
 * @returns 默认路由
 */
const findIndexRoute = (routes: RouteConfig[]) => {
  return routes.find(({ index }) => index === true) ?? routes[0]
}

/**
 * 把路由配置转换成菜单配置
 *
 * @param routes 路由配置
 * @returns 菜单配置
 */
const transform = (routes: RouteConfig[]): ResourceConfig[] => {
  return routes.map(
    ({
      key,
      keys,
      path,
      isPage,
      title,
      uuid,
      icon,
      index,
      hideInMenu,
      hideChildrenInMenu,
      children
    }) => {
      let realPath = path

      if (hideChildrenInMenu && children) {
        if (!path) {
          const indexRoute = findIndexRoute(children)
          realPath = indexRoute.path
        }
      }

      return {
        key,
        keys,
        title,
        icon,
        index,
        isPage,
        hideInMenu,
        hideChildrenInMenu,
        uuid,
        path: realPath,
        children: children && transform(children)
      }
    }
  )
}

/**
 * 路由配置转换成菜单配置
 *
 * @param routes 路由配置
 * @returns 菜单配置
 */
export const transformResources = (routes: RouteConfig[]): ResourceConfig[] => {
  const filteredResources = filterMenuConfigs(routes)
  return transform(filteredResources)
}
